lmApp
  .service('AssetV2Service', ['$rootScope', '$q', '$http',
    function ($rootScope, $q, $http) {
      var service = {};

      service.GetStream = function(assetId, resourceId, token) {
        var deferred = $q.defer();

        var request = {
          headers: {
            'X-Auth-Token': token,
            'X-Instance-Check': ''
          }
        };
        request.url = '/discovery:80/sdp/v2/assets/' + assetId + '/resources/' + resourceId + '/url';
        request.method = 'GET';

        $http(request)
            .then(function (response) {
              var answer = response.data;
              deferred.resolve(answer);
            }, function (response) {
              var reason = {};
              reason.url = request.url;
              reason.data = response.data;
              deferred.reject(reason)
            });
        return deferred.promise;
      };

        service.GetProtectedStream = function(assetId, resourceId, token) {
            var deferred = $q.defer();

            var request = {
                headers: {
                    'X-Auth-Token': token,
                    'X-Instance-Check': ''
                }
            };
            request.url = '/discovery:80/sdp/v2/assets/' + assetId + '/resources/' + resourceId + '/playback-sessions';
            request.method = 'POST';

            $http(request)
                .then(function (response) {
                    var answer = response.data;
                    deferred.resolve(answer);
                }, function (response) {
                    var reason = {};
                    reason.url = request.url;
                    reason.data = response.data;
                    deferred.reject(reason)
                });
            return deferred.promise;
        };

      return service;
    }]);
